import {AuthClaims} from "./useUserPermissions.types";

const authClaims: AuthClaims = {
  moduleAccess: [{
    type: "access",
    value: "accounts"
  }],
  accounts: [{
    type: "access",
    value: "accounts"
  }],
  clients: [{
    type: "access",
    value: "clients"
  }],
  impersonateUser: [{
    type: "access",
    value: "ImpersonateUser"
  }],
  getUserById: [{
    type: "access",
    value: "Account_GetUserById"
  }]
} as AuthClaims;

export {authClaims};
